/**
 * Formate une date UTC vers la timezone locale de l'utilisateur
 * @param {string} utcDateString - Date au format ISO 8601 en UTC (ex: "2024-01-15T10:30:00.000Z")
 * @param {Object} options - Options de formatage personnalisées (optionnel)
 * @returns {string} Date formatée dans la timezone locale (ex: "15 janv. 2024, 11:30")
 */
export const formatDateWithTimezone = (utcDateString, options = {}) => {
  try {
    // Vérifier si la date est fournie
    if (!utcDateString) return '-';

    // Créer un objet Date à partir de la chaîne UTC
    const date = new Date(utcDateString);

    // Vérifier si la date est valide
    if (isNaN(date.getTime())) {
      console.warn('Invalid date string:', utcDateString);
      return '-';
    }

    // Options par défaut pour le formatage français avec heure
    const defaultOptions = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    };

    // Fusionner les options par défaut avec les options personnalisées
    const mergedOptions = { ...defaultOptions, ...options };

    // Formatter avec la timezone locale du navigateur
    return date.toLocaleDateString("fr-FR", mergedOptions);
  } catch (error) {
    console.error('Error formatting date:', error);
    return '-';
  }
};

/**
 * Formate une date UTC vers la timezone locale sans l'heure
 * @param {string} utcDateString - Date au format ISO 8601 en UTC
 * @returns {string} Date formatée sans l'heure (ex: "15 janv. 2024")
 */
export const formatDateOnly = (utcDateString) => {
  return formatDateWithTimezone(utcDateString, {
    hour: undefined,
    minute: undefined
  });
};

/**
 * Formate une date UTC avec un format personnalisé pour les dates de naissance
 * Utilise le format DD/MM/YYYY pour une meilleure lisibilité des dates de naissance
 * @param {string} utcDateString - Date au format ISO 8601 en UTC
 * @returns {string} Date formatée pour les dates de naissance (ex: "15/01/2024")
 */
export const formatBirthDate = (utcDateString) => {
  return formatDateWithTimezone(utcDateString, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: undefined,
    minute: undefined
  });
};